/**
 * Đăng ký các app nặng dạng lazy. Mỗi app thành 1 chunk JS + CSS riêng, chỉ tải khi mở.
 */
import { createLazyController } from '../core/lazy/lazyController.js';

const VIDEO_OPTS = {
  asyncMethods: [],
  noopMethods: ['toggleFullscreen', 'deactivate', 'panicExit']
};
const WORKSPACE_OPTS = {
  asyncMethods: ['activate'],
  noopMethods: ['deactivate', 'pauseVideo', 'panicExit']
};

export function createLazyApps({ playerEngine, onPanicExit }) {
  return {
    capcutController: createLazyController('capcutController',
      () => import('./capcutApp.js').then((m) => m.mount({ playerEngine })), VIDEO_OPTS),
    canvaController: createLazyController('canvaController',
      () => import('./canvaApp.js').then((m) => m.mount({ playerEngine })), VIDEO_OPTS),
    emulatorController: createLazyController('emulatorController',
      () => import('./emulatorApp.js').then((m) => m.mount({ onPanicExit })), WORKSPACE_OPTS),
    figmaController: createLazyController('figmaController',
      () => import('./figmaApp.js').then((m) => m.mount({ onPanicExit })), WORKSPACE_OPTS),
    vscodeController: createLazyController('vscodeController',
      () => import('./vscodeApp.js').then((m) => m.mount({ onPanicExit })), WORKSPACE_OPTS),
    calendarController: createLazyController('calendarController',
      () => import('./caroApp.js').then((m) => m.mount()), {
        asyncMethods: ['showRoute'],
        noopMethods: ['leaveView']
      }),
    adminController: createLazyController('adminController',
      () => import('./adminApp.js').then((m) => m.mount()), {
        asyncMethods: ['activate'],
        noopMethods: ['deactivate']
      })
  };
}

/**
 * Tải trước (prefetch) chunk của app khi trình duyệt rảnh hoặc khi rê chuột vào icon app,
 * để lúc bấm mở gần như tức thì.
 */
export function prefetchOnIntent(apps) {
  const map = {
    capcut: apps.capcutController, canva: apps.canvaController,
    emulator: apps.emulatorController, figma: apps.figmaController,
    vscode: apps.vscodeController, calendar: apps.calendarController,
    admin: apps.adminController
  };
  const handler = (e) => {
    const el = e.target.closest?.('[data-route], [href^="#/"], [id^="theme-opt-"]');
    if (!el) return;
    const key = (el.dataset.route || el.getAttribute('href') || el.id || '')
      .replace('#/', '').replace('theme-opt-', '').split('?')[0];
    map[key]?.ensure().catch(() => {});
  };
  document.addEventListener('pointerover', handler, { passive: true });
  document.addEventListener('touchstart', handler, { passive: true });
}
